var CryptoJS = require("crypto-js");
let secretKey = process.env.NEXT_PUBLIC_SECRET_KEY;

const setEncryptedCookie = (name: string, value: string, days: number) => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }
  let encryptedValue = CryptoJS.AES.encrypt(value, secretKey).toString();
  document.cookie = `${name}=${encryptedValue || ""}${expires}; path=/`;
}

const getEncryptedCookies = (name: string) => {
  let nameEQ = name + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) {
      let value = c.substring(nameEQ.length, c.length);
      return CryptoJS.AES.decrypt(value, secretKey).toString(CryptoJS.enc.Utf8);
    }
  }
  return null;
}

const desCrypto = (value: string) => {
  return CryptoJS.AES.decrypt(value, secretKey).toString(CryptoJS.enc.Utf8);
}

export { setEncryptedCookie, getEncryptedCookies, desCrypto };